import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import ModeToggle from './ModeToggle';
import { NAV_ITEMS } from './navConfig';

// Fixed bottom tab bar (mobile). Uses router hooks, so it lives inside <HashRouter>.
const BottomNav = () => {
  const { COLORS } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, background: COLORS.surface, borderTop: `1px solid ${COLORS.border}`, display: 'flex', zIndex: 50, paddingBottom: 'env(safe-area-inset-bottom)' }}>
      {NAV_ITEMS.map(item => {
        const active = location.pathname === `/${item.id}`;
        return (
          <button key={item.id} onClick={() => navigate(`/${item.id}`)} style={{ flex: 1, padding: '12px 0', background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <span style={{ fontSize: 10, fontWeight: 600, color: active ? COLORS.accent : COLORS.textMuted, fontFamily: 'inherit' }}>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
};

// The original mobile experience: centered 480px column, sticky header, bottom nav.
// Kept behavior-identical to before the routing refactor.
const MobileLayout = ({ children }) => {
  const { COLORS } = useTheme();
  const { user } = useAuth();

  return (
    <div style={{ minHeight: '100vh', background: COLORS.bg, fontFamily: "'DM Sans', sans-serif", maxWidth: 480, margin: '0 auto' }}>
      <div style={{ position: 'sticky', top: 0, zIndex: 50, background: COLORS.bg, borderBottom: `1px solid ${COLORS.border}`, padding: 'calc(14px + env(safe-area-inset-top)) 16px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: COLORS.text, fontSize: 20, fontWeight: 800, letterSpacing: -0.5 }}>Nest Book</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ModeToggle />
          <span style={{ color: COLORS.textMuted, fontSize: 13 }}>Hey, {user?.name?.split(' ')[0]}</span>
        </div>
      </div>
      <div style={{ paddingBottom: 'calc(80px + env(safe-area-inset-bottom))' }}>
        {children}
      </div>
      <BottomNav />
    </div>
  );
};

export default MobileLayout;
